module.exports = __webpack_public_path__ + "img/ka3-2.569fc60a.png";